module.exports = __webpack_public_path__ + "img/cancun-bay-room-5.429c7585.jpg";